<template>
    <div>
        <div class="banner">
            <b-container>
                <h1>Build great apps</h1>
                <p>
                    C-Suite Labs is a tech+marketing agency focused on building exceptional products.
                    We've worked with brands like Disney, Starbucks and Coca Cola.
                    We're also the people behind <a href="https://www.csuitecircle.com" target="_blank" rel="noopener">C-Suite Circle</a>, the world’s largest network of senior business leaders.
                </p>
                <div class="text-center mb-5">
                  <btn primary rounded href="https://csuitecircle.typeform.com/to/kRq9YGX8">Build your App With Us</btn>
                </div>
                <figure>
                    <a href="https://www.csuitecircle.com" target="_blank" rel="noopener" aria-label="map">
                        <img src="@/assets/img/Map_Desktop@2x.png" alt="" class="desktop-map-img">
                        <img src="@/assets/img/Map_Mobile@2x.png" alt="" class="mobile-map-img">
                    </a>
                    <figcaption>Map of C-Suite Circle key cities</figcaption>
                </figure>
            </b-container>
        </div>

        <div class="stats">
            <b-container>
                <b-row>
                    <b-col lg="4">
                        <b-card>
                            <b-card-title>
                                <span>100</span> million installs
                            </b-card-title>
                            <b-card-text>We've created apps and games used by over 100 million people, including 3 global #1 hits.</b-card-text>
                        </b-card>
                    </b-col>
                    <b-col lg="4">
                        <b-card>
                            <b-card-title>
                               <span>10</span> million followers
                            </b-card-title>
                            <b-card-text>We've helped brands (including our own) gain over 10 million followers on major social platforms.</b-card-text>
                        </b-card>
                    </b-col>
                    <b-col lg="4">
                        <b-card>
                            <b-card-title>
                                <span>1</span> million daily users
                            </b-card-title>
                            <b-card-text>Over 1 million people use products developed or enhanced by our specialists every day.</b-card-text>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <div class="startup-benefits">
            <b-container>
                <div class="section-header">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="18" viewBox="0 0 19.5 18"><path class="a" d="M13.36,8.5v-4H3.375v18h19.5V8.5Zm-5.991,12h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2v-2h2Zm3.994,12h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2v-2h2Zm9.516,12H13.36v-2h2v-2h-2v-2h2v-2h-2v-2h7.519Zm-1.763-8h-2v2h2Zm0,4h-2v2h2Z" transform="translate(-3.375 -4.5)"/></svg>
                    </div>
                    <h2>We love small business</h2>
                    <p>Starting a business is tough. That's why we offer steep discounts for any client with less than $10 million in annual revenues, plus options for equity financing.</p>
                    <div class="text-center">
                      <btn primary rounded href="https://csuitecircle.typeform.com/to/kRq9YGX8">Build your App With Us</btn>
                    </div>
                </div>
            </b-container>
        </div>

        <div class="our-clients">
            <b-container>
                <div class="section-header">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="18" viewBox="0 0 19.5 18"><path class="a" d="M13.36,8.5v-4H3.375v18h19.5V8.5Zm-5.991,12h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2v-2h2Zm3.994,12h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2v-2h2Zm0-4h-2v-2h2Zm9.516,12H13.36v-2h2v-2h-2v-2h2v-2h-2v-2h7.519Zm-1.763-8h-2v2h2Zm0,4h-2v2h2Z" transform="translate(-3.375 -4.5)"/></svg>
                    </div>
                    <h2>Our Clients</h2>
                    <p>We’ve had the privilege of building tech and marketing solutions for some of the world’s most influential companies.</p>
                    <router-link to="/portfolio" class="link">
                        Explore Our Portfolio
                        <img src="https://img.icons8.com/ios/37/7347A8/long-arrow-right.png" alt="" />
                    </router-link>
                    <div class="text-center">
                      <btn primary rounded href="https://csuitecircle.typeform.com/to/kRq9YGX8">Build your App With Us</btn>
                    </div>
                </div>
                <b-row class="mt-5">
                    <b-col sm="6" md="3" lg="3" v-for="client in clients" :key="client.name" class="mb-4">
                        <div class="logo">
                            <b-img :src="client.picture" center fluid :alt="client.name" :title="client.name"></b-img>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <div class="our-services">
            <b-container>
                <div class="section-header">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19.65" viewBox="0 0 23 19.65"><path class="a" d="M11.5,21.493,2.156,16.822,0,17.9l11.5,5.75L23,17.9l-2.156-1.078Zm0-4.069L2.156,12.752,0,13.83l11.5,5.75L23,13.83l-2.156-1.078ZM23,9.75,11.5,4,0,9.75,11.5,15.5ZM11.5,6.143,18.714,9.75,11.5,13.357,4.286,9.75Z" transform="translate(0 -4)"/></svg>
                    </div>
                    <h2>Our Services</h2>
                    <p>We offer consulting services to select clients, leveraging our unique history of building successful world-class tech products.</p>
                    <router-link to="/services" class="link">
                        Explore Our Services
                        <img src="https://img.icons8.com/ios/37/7347A8/long-arrow-right.png" alt="" />
                    </router-link>
                    <div class="text-center">
                      <btn primary rounded href="https://csuitecircle.typeform.com/to/kRq9YGX8">Build your App With Us</btn>
                    </div>
                </div>
                <b-row class="mt-5 justify-content-center">
                    <b-col md="6" lg="4" v-for="service in services" :key="service.name" class="mb-4">
                        <b-card no-body>
                            <b-card-title>
                                <img :src="service.icon" alt="" />
                                {{ service.name }}
                            </b-card-title>
                            <b-card-img :src="service.thumbnail" alt="image" bottom></b-card-img>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <div class="our-people">
            <b-container>
                <div class="section-header">
                    <h2>Our People</h2>
                    <p>Our people are our greatest asset. Meet our team today.</p>
                    <router-link to="/people" class="link">
                        Meet Our People
                        <img src="https://img.icons8.com/ios/37/9B64BE/long-arrow-right.png" alt="" />
                    </router-link>
                    <div class="text-center">
                      <btn primary rounded href="https://csuitecircle.typeform.com/to/kRq9YGX8">Build your App With Us</btn>
                    </div>
                </div>
            </b-container>
            <team-slider class="mt-5" />
        </div>
    </div>
</template>
<script>
import ClientData from '@/data/clients.json';
import ServicesData from '@/data/services.json';
import TeamSlider from '@/components/home/TeamSlider';
import Btn from '@/components/global/Btn.vue';

export default {
    components: {
        TeamSlider,
        Btn,
    },
    data () {
        return {
            clients: ClientData,
            services: ServicesData,
        };
    },
};
</script>
<style lang="scss" scoped>
h1,
h2 {
    font-weight: 900;
    text-align: center;
}

h1 {
    font-size: 42px;
    margin-bottom: 15px;
    @include media-breakpoint-up(md) {
        font-size: 50px;
        margin-bottom: 30px;
    }
}

h2 {
    font-size: 36px;
    margin-bottom: 15px;
    color: #000112;
    @include media-breakpoint-up(md) {
        font-size: 40px;
    }
}

img {
    max-width: 100%;
}

p {
    font-size: 20px;
    line-height: 38px;
}

figcaption {
    // color: #555;
    color: #a8a8a8;
}

.section-header .icon {
    width: 43px;
    height: 43px;
    background-color: #9B64BE;
    box-shadow: 5px 6px 26px rgba(155, 100, 190, 0.43);
    border-radius: 10px;
    margin: 0 auto 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        fill: #ffffff;
    }
}

.section-header p {
    max-width: 550px;
    margin: 0 auto 20px;
    text-align: center;
    color: #3E4041;
    font-size: 16px;
    line-height: 28px;
    @include media-breakpoint-up(md) {
        font-size: 20px;
        line-height: 32px;
    }
}

.section-header a.link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin: 0 auto 15px;
    font-size: 18px;
    outline: none;
    img {
        margin-left: 10px;
    }
}

.banner {
    padding: 45px 0;
    background-color: #000112;
    color: #ffffff;
    text-align: center;
    @include media-breakpoint-up(md) {
        padding: 58px 0;
    }
    p {
        max-width: 700px;
        margin: 0 auto 40px;
        a {
            color: #9B64BE;
        }
    }
    img {
        margin: 15px auto;
        margin-bottom: 0px;
        @include media-breakpoint-up(md) {
            margin: 10px auto;
            min-height: 270px;
        }
    }
    .desktop-map-img {
        display: none;
        @include media-breakpoint-up(lg) {
            display: block;
        }
    }
    .mobile-map-img {
        display: block;
        @include media-breakpoint-up(lg) {
            display: none;
        }
    }
}

.stats {
    background-color: #4B2E6E;
    background-image: url('~@/assets/img/Head_decor_768.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom right;
    padding: 30px 0;
    text-align: center;
    @include media-breakpoint-up(lg) {
        text-align: left;
        background-image: url('~@/assets/img/Head_decor_wide.png');
        background-position: bottom center;
    }
    .card {
        background: transparent;
        color: #ffffff;
        border: none;
    }
    .card-body {
        padding: 0;
    }
    h4 {
        font-size: 26px;
        font-weight: 900;
        @include media-breakpoint-up(md) {
            font-size: 30px;
        }
        span {
            font-size: 44px;
            @include media-breakpoint-up(md) {
                display: block;
                font-size: 52px;
            }
        }
    }
    .card-text {
        font-size: 16px;
        line-height: 25px;
        max-width: 400px;
        margin: 0 auto 15px;
        @include media-breakpoint-up(lg) {
            max-width: 100%;
        }
    }
}

.our-clients {
    padding: 60px 0 30px;
    @include media-breakpoint-up(md) {
        padding: 85px 0 40px;
    }
    .logo {
        background-color: #ffffff;
        box-shadow: 0px 20px 35px rgba(0, 0, 0, 0.08);
        border-radius: 5px;
        text-align: center;
        @include media-breakpoint-up(sm) {
            height: 100%;
        }
    }
}

.our-services {
    padding: 30px 0 60px;
    @include media-breakpoint-up(md) {
        padding: 30px 0 70px;
    }
    .icon {
       box-shadow: 5px 6px 26px #7347A889;
       background-color: $primary;
    }
    a.link {
        color: $primary;
    }
    .card-title {
        background-color: $primary;
        color: #ffffff;
        text-align: center;
        margin-bottom: 0;
        padding: 20px 0 25px;
        font-size: 24px;
        font-weight: 700;
        img {
            width: 48px;
            height: 48px;
            display: block;
            margin: 15px auto;
        }
    }
    .row > div {
        &:first-of-type .card-title {
            background-color: #4B2E6E;
        }
        &:nth-of-type(2) .card-title {
            background-color: #7347A8;
        }
        &:nth-of-type(3) .card-title {
            background-color: #9B64BE;
        }
    }
}

.our-people {
    padding: 70px 0;
    background-color: #0B0124;
    color: #ffffff;
    .section-header h2,
    .section-header p {
        color: #ffffff;
    }
    a.link {
        color: #9B64BE;
    }
}
.startup-benefits {
  background-color: white;
  padding: 70px 0;
}
</style>
